import { CropProtectionRecommendationDetailCardPDF } from '../crop-protection/output/recommendation';
import colors from '../theme-provider/colors';

const RecommendationCropProtectionPDF = ({ recommendation }) => {
    const expertoTheme = colors.themes.expertobayer;

    return <CropProtectionRecommendationDetailCardPDF pdfTheme={expertoTheme} recommendation={recommendation} />;
};

export default RecommendationCropProtectionPDF;
